import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

import {
  TableWaitingSwitchmanRequest,
  TableSwitchmanRequest,
  TableWaitingTeacherRequest,
  TableTeacherRequest,
} from '@features/inquiries/components/DirectInquiries/TablesDirect';

import { useDirectInquiries } from '@features/inquiries/hooks/useInquiryQueries';

const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  rightRefresh: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    alignItem: 'flex-end',
    justifyContent: 'flex-end',
  },
}));

const TabDirect = ({ setSettings }) => {

  const classes = useStyles();

  // Utilisation du hook React Query
  const { data: directInquiries = {}, refetch } = useDirectInquiries();

  const {
    waitingSwitchman = [],
    withSwitchman = [],
    waitingTeacher = [],
    withTeacher = []
  } = directInquiries;

  const handleRedirectAlarm = () => {
    setSettings(true);
  };

  return (
    <div className={classes.column}>
      {/* Requêtes en attente d'aiguillage */}
      <div className={classes.row}>
        <Tooltip title="Paramètre d'alarme">
          <IconButton aria-label="alarm" onClick={handleRedirectAlarm}>
            <NotificationsActiveIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Rafraichir">
          <IconButton aria-label="refresh" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </div>
      <TableWaitingSwitchmanRequest waitingSwitchmanInquiries={waitingSwitchman} />

      {/* Requêtes en cours d'aiguillage */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableSwitchmanRequest switchmanInquiries={withSwitchman} />

      {/* Requêtes en attente de traitement */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableWaitingTeacherRequest waitingTeacherInquiries={waitingTeacher} />

      {/* Requêtes en cours de traitement */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableTeacherRequest teacherInquiries={withTeacher} />

    </div>
  );
};

export default TabDirect;
